module.exports = __webpack_public_path__ + "img/bold-download.5655c2c9.svg";